var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-social-long-twitter"},[_c('a',{attrs:{"href":"https://twitter.com/intent/tweet?url=https://siruq.site&&hashtags=しるQ&related=Q18807506","target":"_blank"}},[_c('v-fa',{attrs:{"icon":['fab', 'twitter']}}),_vm._v(" 回答する")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf8fcf8c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnswerBtn.vue
// module id = null
// module chunks = 